"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const OverlayTrigger_1 = tslib_1.__importDefault(require("react-bootstrap/OverlayTrigger"));
const omit_1 = tslib_1.__importDefault(require("lodash/omit"));
const Placement_1 = require("../../values/Placement");
const Trigger_1 = require("../../values/Trigger");
const OverlayTrigger = (props) => {
    const usedProps = Object.assign({ rootClose: true }, (0, omit_1.default)(props, 'children'));
    const { children } = props;
    // @ts-ignore
    return (0, jsx_runtime_1.jsx)(OverlayTrigger_1.default, Object.assign({}, usedProps, { children: children }));
};
OverlayTrigger.TRIGGER_CLICK = Trigger_1.TRIGGER.CLICK;
OverlayTrigger.TRIGGER_HOVER = Trigger_1.TRIGGER.HOVER;
OverlayTrigger.TRIGGER_FOCUS = Trigger_1.TRIGGER.FOCUS;
// placement
OverlayTrigger.AUTO_START = Placement_1.PLACEMENT.AUTO_START;
OverlayTrigger.AUTO = Placement_1.PLACEMENT.AUTO;
OverlayTrigger.AUTO_END = Placement_1.PLACEMENT.AUTO_END;
OverlayTrigger.TOP_START = Placement_1.PLACEMENT.TOP_START;
OverlayTrigger.TOP = Placement_1.PLACEMENT.TOP;
OverlayTrigger.TOP_END = Placement_1.PLACEMENT.TOP_END;
OverlayTrigger.RIGHT_START = Placement_1.PLACEMENT.RIGHT_START;
OverlayTrigger.RIGHT = Placement_1.PLACEMENT.RIGHT;
OverlayTrigger.RIGHT_END = Placement_1.PLACEMENT.RIGHT_END;
OverlayTrigger.BOTTOM_START = Placement_1.PLACEMENT.BOTTOM_START;
OverlayTrigger.BOTTOM = Placement_1.PLACEMENT.BOTTOM;
OverlayTrigger.BOTTOM_END = Placement_1.PLACEMENT.BOTTOM_END;
OverlayTrigger.LEFT_START = Placement_1.PLACEMENT.LEFT_START;
OverlayTrigger.LEFT = Placement_1.PLACEMENT.LEFT;
OverlayTrigger.LEFT_END = Placement_1.PLACEMENT.LEFT_END;
exports.default = OverlayTrigger;
